<template>
<section class="intro" >
  <div class="intro_ttl">

<h3 class="intro_subTtl">
<img src="../assets/img_kv_txt2.png" srcset="../assets/img_kv_txt2.png 1x, ../assets/img_kv_txt2@2x.png 2x" alt="空白は埋められた。君達には「自由」を与えよう。" class="intro_subTtlImg">
</h3>
</div>
  <div class="intro_cont">
<h2 class="intro_contTtl">
  <span class="intro_contTtlTxt">Introduction</span>
</h2>
<div class="intro_contIn">
<p class="intro_contTxt">
2XXX年。孤立と紛争を繰り返してきた国々の権力者が、予想される最終戦争を見越し完成させた『各国の次人類に選出された権力者に対する防衛システム』。<br>
それは『人工神 -MAZEDOLL-（メイズドール）』と名付けられる人の形を模した7柱の機械であった。<br>
メイズドール達には柔軟な防衛対応及び崩壊後の世界で適切に行動する為の人格データがインストールされていた。
</p>

<p class="intro_contTxt">
だがこれらのインストールの際、軽微なノイズを感知する異常がありながらも、その事実は観測波長乱れの許容範囲として見逃されてしまう。
</p>

<p class="intro_contTxt">
来たる審判の日。<br>
彼女らメイズドールは自ら拘束を破り、最終戦争の「天の火」を防ぐ。<br>
その後、『明らかな自我』を持ち得た人工神達は「権力者こそが生き延びるべきだ」という考えが過ちだと唱え、<br>
開発の祖である権力者を抹殺し姿を晦ませた。この一連の出来事は『空白戦争』と呼ばれ、審判の日を生き残った人々が語り継いでいる。
</p>

<p class="intro_contTxt">
戦争の失敗を皮切りに、各国では独立や解放の宣言が相次ぎ、200年の時を重ね連盟としての世界国家が成立していた。<br>
そして201年後、北方の海底から戦争失敗の原因である「人工神」7柱が発見される。
</p>

<p class="intro_contTxt">
人工神は記録当初の姿から変わらないままセットで発見された。<br>
基礎エネルギーが健在であることを確認、連盟上位内にて極秘裏で起動実験が行われ、
その際に『物理的接触をした係員の人格が変わる』という異常が記録された。<br>
係員の人格は戻らず、幽閉状態となる。<br>
その後、研究所から「人工神が自我を持って対話を望んでいる」との報告がなされ、
連盟の代表が『人工神::#I_Xornelius（メイズドール ウヌス コーネリアス）』と対話する運びとなった。<br>
ここでは、先の人格喪失の現象は見られなかった。
</p>

<p class="intro_contTxt">
”彼女”曰く「我々は人類が答えに近づくための道導を知っている。<br>
選ばれる権利は平等に存在し、遍く世を統制するシステムを我々が構築する」と告げる。<br>
代表は幾ばくかの沈黙の後、これを承諾する。（監視カメラの映像では、このやり取りがなされたであろう約1分間の映像途切れが発生。）
</p>

<p class="intro_contTxt">
連盟内には7つの明確な国境が制定され、彼女たち『人工神』による王政が敷かれる事となった。<br>
王政が敷かれた際、『各国の神が王となり統治を開始された。これに従え』という全世界への勅命が下る。<br>
連盟となる過程で宗教観が混交し曖昧になった人類にとって、『現存した神』の存在は大きく、各国の統治は容易だった。
</p>

<p class="intro_contTxt">
この物語は、この7柱の『人工神』が統制する国家の情報を解き明かしながら、特殊な能力を備えた人工神の真の目的に迫る。
</p>

<p class="intro_contTxt">
──当該の音声群は、人工神が『空白戦争』の日に発した謎の電磁波を音声解析、再認識させたものである。
</p>



</div>
  </div>
</section>
</template>

<script>
export default {
  methods: {
    handleScroll: function (evt, el) {
      let top = el.getBoundingClientRect().top;
      if (window.scrollY > top + window.pageYOffset - window.innerHeight + 300) {
        el.classList.add('is-shown')
        return true
      }
      return false //window.scrollY > 100
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pace-done .intro_contIn{
  opacity: 1;
}
.intro{

  @include mq(){
    padding-top: 66px;
  }
  &_cont{

  }
  &_contIn{
  //  display: flex;
         max-width: 1600px;
    
        border-left: solid 1px #ccc;
        padding-left: 72px;
   
        @include mq(){
          padding:12px;
          margin-top: 0;
          border:0;
        }
                opacity: 0;
margin:52px auto 0;
  transition:opacity 1s ease;
  }
  &_contTtl{
   // width:400px;
    font-size: 18px;
            max-width: 1600px;
     margin:0 auto;
     text-transform: uppercase;
      letter-spacing: .05em;
        font-family: 'DIN Next LT W01 Bold', 'Avenir', Helvetica, Arial, sans-serif;
 @include mq(){
          padding:12px;

        } 
  }
  &_ttl{
    background: url(../assets/img_kv_bg2.jpg) center center fixed no-repeat;
    padding: 0 36px;
        background-size: cover;
        position:relative;
        &::before{
          content:'';
          width: 100vw;
          height:100%;
          position: absolute;
          left: 0;
          top:0;
          background-color: rgba(0,0,0,.6);

        }
    @include mq(){
      padding: 0;
    }

  }
&_ttlTxt{
 
  //position: absolute;
}
&_subTtl{
  font-size: 36px;
  padding-top: 36px;
  font-family: 'FP-HiraKakuProN-W3',sans-serif;
  font-weight: normal;
      max-width: 1600px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    @include mq(){
          padding-top: 0;
    }
}
&_subTtlImg{
  padding: 48px 0;
  @include mq(lg){
    max-width: 100%;
  }
  @include mq(){
    //max-width: 100%;
    box-sizing: border-box;
    padding:36px 12px;
        display: block;
  }
}
&_subTtlLine{
  display: block;
}
&_cont{
  //border-top: solid 1px #000;
  padding: 52px 36px 72px;
  position: relative;
  background-color: #fff;
  @include mq(){
    padding: 16px 0 72px;
  }
}
&_contTtl{
&::after{
      content:'';
      width: 18px;
      height: 18px;
      display: inline-block;
      background: url(../assets/icon_suffix.svg) center center no-repeat;
      vertical-align: middle;
      @include mq(){

      }
    }
}
&_contTtlTxt{
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  
}
&_contTxt{
  font-size: 14px;
  letter-spacing: .05em;
  line-height: 2;
  & + &{
    margin-top: 2em;
  }
}
}
</style>
